import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lightIcon", "darkIcon"]

  connect() {
    this.applyIcons()
  }

  toggle() {
    const current = document.documentElement.getAttribute("data-theme")
    const next = current === "dark" ? "light" : "dark"
    document.documentElement.setAttribute("data-theme", next)
    localStorage.setItem("theme", next)
    this.applyIcons()
  }

  applyIcons() {
    const isDark = document.documentElement.getAttribute("data-theme") === "dark"
    this.lightIconTarget.classList.toggle("hidden", !isDark)
    this.darkIconTarget.classList.toggle("hidden", isDark)
  }
}
